module.exports = __webpack_public_path__ + "static/media/facebookLogo.8ddf76a1.png";